export const GOOGLE_MEET_OAUTH_MESSAGE_TYPE = 'google-meet-oauth-code'
export const GOOGLE_MEET_OAUTH_STORAGE_KEY = 'google_meet_oauth_callback'
